import Lottie from "lottie-react";
import * as animationData from "../../assets/loading-bar.json";

export function LottieLoading({className, lottieClassName}: {
  className?: string
  lottieClassName?: string
}) {
  return (
    <div className={`flex justify-center items-center h-[100vh] ${className}`}>
      <Lottie
        animationData={animationData}
        loop={true}
        className={`w-[175px] h-[100px] ${lottieClassName}`}
      />
    </div>
  );
}
